import { pathOr } from 'ramda';

export const isServer = typeof window === 'undefined';

export const isClient = !isServer;

export const getUserAgent = () => navigator.userAgent;

export const Android = () => /Android/i.test(getUserAgent()) && !Windows();

export const iPhone = () =>
  /iPhone/i.test(getUserAgent()) && !iPad() && !Windows();

export const iPod = () => /iPod/i.test(getUserAgent());

export const iPad = () => /iPad/i.test(getUserAgent());

export const iOS = () => iPad() || iPod() || iPhone();

export const Windows = () =>
  /Windows Phone|IEMobile|WPDesktop/i.test(getUserAgent());

export const getPlatform = () => {
  if (isServer) return 'unknown';
  if (Android()) return 'android';
  if (iOS()) return 'ios';
  return 'desktop';
};

export const getEnvironment = () =>
  isServer ? process.env : pathOr({}, ['REDUX_STATE', 'environment'], window);

export const gameTypeFromProduct = (product) =>
  product == 'waybetter' ? 'falkor' : product;

export const gameTypeFromTheme = gameTypeFromProduct;

export const isWaybetterProduct = (product) =>
  ['waybetter', 'falkor'].includes(product);

export const themeFromProduct = (product) =>
  product == 'falkor' ? 'waybetter' : product;

export const publicEnvironmentVariables = [
  'ALGOLIA_SEARCH',
  'APPLE_CLIENT_ID',
  'BASE_CONTENTFUL_IMAGE_URL',
  'BRANCH_DIETBET_APP_KEY',
  'BRANCH_RUNBET_APP_KEY',
  'BRANCH_STEPBET_APP_KEY',
  'BRANCH_WAYBETTER_APP_KEY',
  'CLOUDINARY_CLOUD_NAME',
  'CONTENTFUL_SPACE_ID',
  'DEFAULT_DIETBET_OFFER',
  'DEFAULT_STEPBET_OFFER',
  'DEFAULT_WAYBETTER_OFFER',
  'DIETBET_AF_SMART_BANNER_KEY',
  'DIETBET_GAME_SERVICE_HOST',
  'ERROR_REPORTING_ENABLED',
  'ERROR_REPORTING_HOSTS',
  'ERROR_REPORTING_VIA_CONSOLE',
  'FACEBOOK_CLIENT_ID',
  'FF_WBRT_1927_USE_GOOGLE_SIGN_IN_V2',
  'FF_WBRT_2630_DISABLE_DIETBET_MEMBERSHIP_STATUS',
  'FF_WBRT_4997_HUB_USE_WB_ASSET_SERVICE',
  'GOOGLE_CLIENT_ID',
  'GOOGLE_PAY_MERCHANT_ID',
  'GRAPHQL_URL',
  'QUIZ_CHECKOUT_CHART_PUBLIC_ID',
  'LOG_GRAPHQL_QUERIES',
  'MAILCHIMP_HOST',
  'MAILCHIMP_ID',
  'OPTIMIZELY_SDK_KEY',
  'OP_DEFAULT_GAME_IMAGES',
  'OP_USER_GAME_IMAGES',
  'OP_USER_WIDE_GAME_IMAGES',
  'QUIZ_HOST',
  'RECAPTCHA_SITE_KEY',
  'SENTRY_DSN',
  'SHARE_DOMAIN',
  'SUPPORT_EMAIL',
  'USE_STATIC_CHECKOUT_CHART',
  'WB_AUTH_SERVICE_BASE_URL',
  'WB_ASSET_ENDPOINT',
  'WB_ENV',
  'WB_HUB_LOG_LEVEL',
  'WB_WEIGHTLOSS_CHART_BASE_URL',
  'WB_WEIGHTLOSS_CHART_BASE_URL_V2',
];

export const isRecordNotFoundError = (error) =>
  error?.message?.includes('ActiveRecord::RecordNotFound');

export const isIntTooLongError = (error) =>
  error?.message?.includes(
    'Int cannot represent non 32-bit signed integer value'
  );
